import classnames from 'classnames';
import React, { PropTypes, Component } from 'react';

import Background from './background';
import Icon from './icon';
import Mask from './mask';
import networks from './networks';

import 'styles/social-icon.scss';

class SocialIcon extends Component {
  getNetworkKey() {
    return this.props.network || networks.keyFor(this.props.url);
  }

  getClassName() {
    return classnames('social-icon', this.props.className);
  }

  render() {
    return (
      <a {...this.props} ref="link" href={this.props.url} target="_blank" className={this.getClassName()}>
        <div className="social-container">
          <svg className="social-svg" viewBox="0 0 64 64">
            <Background ref="background" />
            <Icon ref="icon" networkKey={this.getNetworkKey()} />
            <Mask ref="mask" networkKey={this.getNetworkKey()} color={this.props.color} />
          </svg>
        </div>
      </a>
    );
  }
}

SocialIcon.propTypes = {
    className: React.PropTypes.string,
    color: React.PropTypes.string,
    network: React.PropTypes.string,
    url: React.PropTypes.string
};

export default SocialIcon;



/** WEBPACK FOOTER **
 ** ./src/components/Icons/social-icon.js
 **/